import Link from 'next/link'
import { FastlyImage } from '@components/common/image'
import Button from '@components/atoms/button'
import { t, Trans } from '@lingui/macro'

type Props = {
  isBannerOnCompetitionListPage?: boolean
}

const IMAGE_PATH = '/images/quiz-banner/'

/** i18n support added */
const QuizBanner = ({ isBannerOnCompetitionListPage = false }: Props) => (
  <div className="container mx-auto md:mt-20">
    {isBannerOnCompetitionListPage && (
      <Link href="/quizzes/" prefetch={false}>
        <a className="flex w-full px-2 py-4 bg-white rounded-lg shadow-xl cursor-pointer">
          <div>
            <h4
              className="pb-1 text-2xl leading-7 text-center text-transparent font-700 bg-clip-text"
              style={{
                backgroundImage:
                  'linear-gradient(82.95deg, #BF3240 -6.56%, #7E36D9 122.43%),linear-gradient(0deg, #FF5A43, #FF5A43)',
              }}
            >
              <Trans id="trialClass.join.quizzes.heading">
                Play while you learn and win amazing prizes
              </Trans>
            </h4>
            <FastlyImage
              src={`${IMAGE_PATH}quiz-phone-banner.webp`}
              alt={t`quiz banner image`}
              className="pt-2"
              height={392}
              width={690}
            />
            <p className="px-4 pb-4 text-lg leading-6 text-center text-grey">
              <Trans id="trialClass.join.quizzes.realTimeLeaderboard">
                Real-time leaderboard
              </Trans>{' '}
              <span className="text-4xl text-orange">.</span>{' '}
              <Trans id="trialClass.join.quizzes.weeklyWinnerAwards">
                Weekly winner awards
              </Trans>{' '}
              <span className="text-4xl text-orange">.</span>{' '}
              <Trans id="trialClass.join.quizzes.championships">
                {' '}
                Championships
              </Trans>
            </p>
            <div className="flex justify-center">
              <Button className="shadow-xl">
                <Trans id="trialClass.join.quizzes.ctaText">
                  Take a quiz now
                </Trans>
              </Button>
            </div>
          </div>
        </a>
      </Link>
    )}

    {!isBannerOnCompetitionListPage && (
      <Link href="/quizzes/" prefetch={false}>
        <a className="flex py-4 mx-4 rounded-lg shadow-xl cursor-pointer lg:mx-24 lg:space-x-6 lg:py-0">
          <div className="relative hidden lg:contents w-5/12">
            <FastlyImage
              src={`${IMAGE_PATH}quiz-wide-banner.webp`}
              alt={t`quiz banner image`}
              height={192}
              width={448}
            />
          </div>
          <div className="lg:py-4">
            <h4
              className="px-6 pb-1 text-2xl text-center text-transparent font-700 xl:text-3xl lg:text-left bg-clip-text lg:leading-8 lg:px-0"
              style={{
                backgroundImage:
                  'linear-gradient(82.95deg, #BF3240 -6.56%, #7E36D9 122.43%),linear-gradient(0deg, #FF5A43, #FF5A43)',
              }}
            >
              <Trans id="trialClass.join.quizzes.heading">
                Play while you learn and win amazing prizes
              </Trans>
            </h4>
            <div className="lg:hidden">
              <FastlyImage
                src={`${IMAGE_PATH}quiz-phone-banner.webp`}
                alt={t`quiz banner image`}
                height={392}
                width={690}
              />
            </div>
            <div className="lg:flex pb-3 xl:pb-4 xl:pt-2 pl-3 lg:pl-0 lg:flex-wrap justify-center xl:justify-start">
              <div className="flex items-center px-1">
                <span className="rounded-full bg-orange-600 w-2 h-2" />
                <p className="ml-1 text-left">
                  {' '}
                  <Trans id="trialClass.join.quizzes.realTimeLeaderboard">
                    Real-time leaderboard
                  </Trans>
                </p>
              </div>
              <div className="flex items-center px-1">
                <span className="rounded-full bg-orange-600 w-2 h-2" />
                <p className="ml-1 text-left">
                  <Trans id="trialClass.join.quizzes.weeklyWinnerAwards">
                    Weekly winner awards
                  </Trans>
                </p>
              </div>
              <div className="flex items-center px-1">
                <span className="rounded-full bg-orange-600 w-2 h-2" />
                <p className="ml-1 text-left">
                  <Trans id="trialClass.join.quizzes.championships">
                    Championships
                  </Trans>
                </p>
              </div>
            </div>
            <div className="flex justify-center lg:justify-start">
              <Button className="shadow-xl">
                <Trans id="trialClass.join.quizzes.ctaText">
                  Take a quiz now
                </Trans>
              </Button>
            </div>
          </div>
        </a>
      </Link>
    )}
  </div>
)

export default QuizBanner
